import { render } from "./OpacityTransition.vue?vue&type=template&id=a4d20e2e&scoped=true&ts=true"
import script from "./OpacityTransition.vue?vue&type=script&lang=ts"
export * from "./OpacityTransition.vue?vue&type=script&lang=ts"

import "./OpacityTransition.vue?vue&type=style&index=0&id=a4d20e2e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d20e2e"]])

export default __exports__